export type AppTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'theme';
export const THEME_CHANGE_EVENT = 'app-theme-change';

function isBrowser(): boolean {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

export function resolveInitialTheme(): AppTheme {
  if (!isBrowser()) {
    return 'light';
  }

  const storageTheme = window.localStorage.getItem(THEME_STORAGE_KEY);
  if (storageTheme === 'dark' || storageTheme === 'light') {
    return storageTheme;
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getCurrentTheme(): AppTheme {
  if (!isBrowser()) {
    return 'light';
  }

  const themeFromDataAttr = document.documentElement.dataset.theme;
  if (themeFromDataAttr === 'dark' || themeFromDataAttr === 'light') {
    return themeFromDataAttr;
  }

  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

export function applyTheme(theme: AppTheme): void {
  if (!isBrowser()) {
    return;
  }

  document.documentElement.classList.toggle('dark', theme === 'dark');
  document.documentElement.dataset.theme = theme;
}

export function setTheme(theme: AppTheme): void {
  if (!isBrowser()) {
    return;
  }

  applyTheme(theme);
  window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  window.dispatchEvent(
    new CustomEvent<AppTheme>(THEME_CHANGE_EVENT, {
      detail: theme,
    })
  );
}

export function initializeTheme(): void {
  applyTheme(resolveInitialTheme());
}

